import { render, staticRenderFns } from "./PayrollExceptionSummary.vue?vue&type=template&id=4de9f882"
import script from "./PayrollExceptionSummary.vue?vue&type=script&lang=js"
export * from "./PayrollExceptionSummary.vue?vue&type=script&lang=js"
import style0 from "./PayrollExceptionSummary.vue?vue&type=style&index=0&id=4de9f882&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports